import { VertTimer, VertSkeleton } from '@vertem-core/vertice-ds';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import PropTypes from 'prop-types';
import { fetchTimerDailyOffer } from 'redux/Reducers/Showcases/ShowcaseAutomateReducer';

const ShowCaseTimer = ({ Sku, label }) => {
  const dispatch = useDispatch();
  const { finalDate } = useSelector(
    (state) => state.AutomateShowcase?.fetchTimerDailyOffer
  );

  const { loadingTimer } = useSelector((state) => state.AutomateShowcase);
  const access_token = useSelector((state) => state.oidc.user['access_token']);
  const userProfile = useSelector((state) => state.oidc.user.profile);

  const commonParams = {
    Sku,
    campaignId: userProfile['custom:campaign_id'],
    catalogId: userProfile['custom:catalog_id'],
    participantId: userProfile['custom:participant_id'],
    access_token,
  };

  const fetchTimer = () => {
    dispatch(
      fetchTimerDailyOffer({
        id: Sku,
        ...commonParams,
      })
    );
  };

  useEffect(() => {
    fetchTimer(Sku);
  }, [Sku]);

  return (
    <>
      {loadingTimer && ( 
          <div className="margin-y-extra-small">
            <VertSkeleton title={false} paragraph={{ rows: 1 }} active />
          </div>
      )}
      
      {finalDate && (
        <>
          {label}
          <VertTimer startDate={new Date()} endDate={new Date(finalDate)} />
        </>
      )}
    </>
  );
};

export default ShowCaseTimer;

ShowCaseTimer.propTypes = {
  Sku: PropTypes.string.isRequired,
  label: PropTypes.node,
};
